export class ConfiguratorFieldDependencyController {
  constructor() {
    this.fields = [];
  }

  createDependencyMap() {
    const { fields } = this;

    fields.forEach((field) => {
      field.dependency = {
        ...field.dependency,
        fieldsDependsOnMe: fields.filter((candidate) => candidate.DependentControlId === field.Id),
      };

      const { fieldsDependsOnMe, handleDependencies, htmlInput, triggerOnEvent } = field.dependency;

      // NOTE: Attach listeners ONLY if this field has dependents
      if (fieldsDependsOnMe.length > 0 && handleDependencies && htmlInput && triggerOnEvent) {
        this.attachListeners(htmlInput, triggerOnEvent, handleDependencies);
        field.dependency.listenersAttached = true;
      }

      if (handleDependencies) {
        handleDependencies();
      }
    });
  }

  setDependencyOnField({
    field,
    htmlInput,
    controlToHide,
    that,
    triggerOnEvent,
    getValueCallback,
    onVisibilityChange,
  }) {
    const controller = that || this;
    controller.fields.push(field);

    const handleFieldVisibility = () => {
      const dependents = field.dependency?.fieldsDependsOnMe || [];
      if (dependents.length === 0 || !getValueCallback) return;

      const newValue = getValueCallback(field);
      dependents.forEach((depField) => {
        const shouldShow = this.shouldShowDependent(depField, newValue);
        this.updateDependentVisibility({
          depField,
          shouldShow,
          configuratorRef: controller.configuratorRef || null,
          onVisibilityChange,
        });
      });
    };

    Object.assign(field.dependency || (field.dependency = {}), {
      htmlInput,
      triggerOnEvent,
      controlToHide,
      handleDependencies: handleFieldVisibility,
      hidden: false,
      listenersAttached: false,
    });
  }

  attachListeners(htmlInput, triggerOnEvent, handler) {
    const inputs = Array.isArray(htmlInput) ? htmlInput : [htmlInput];
    inputs.forEach((input) => input.addEventListener(triggerOnEvent, handler));
  }

  /**
   * Cleanup: Detach listeners & reset (call when destroying).
   */
  destroyDependencyMap() {
    const { fields } = this;

    fields.forEach((field) => {
      const { handleDependencies, htmlInput, triggerOnEvent, listenersAttached } =
        field.dependency || {};

      if (listenersAttached && handleDependencies && htmlInput && triggerOnEvent) {
        this.attachListeners(htmlInput, triggerOnEvent, handleDependencies);
        field.dependency.listenersAttached = false;
      }

      // NOTE: Clear fieldsDependsOnMe to free memory
      if (field.dependency) {
        field.dependency.fieldsDependsOnMe = [];
      }
    });
  }

  shouldShowDependent(depField, newValue) {
    const depValue = depField.DependentControlValue;
    return Array.isArray(newValue) ? newValue.includes(depValue) : newValue === depValue;
  }

  updateDependentVisibility({ depField, shouldShow, configuratorRef, onVisibilityChange }) {
    const dep = depField.dependency;
    const targetHidden = !shouldShow;

    if (onVisibilityChange) {
      onVisibilityChange(depField, targetHidden, configuratorRef);
    }

    if (dep.hidden === targetHidden) return;

    dep.controlToHide.style.display = shouldShow ? 'block' : 'none';
    dep.hidden = targetHidden;
  }
}
